import React, { useEffect, useMemo } from 'react'
import { Box } from '@mui/material'
import AnimatedTitle from '../../../components/AnimatedTitle/AnimatedTitle'
import useUserStore from '../../../store/useUserStore'

const CALENDLY_SCRIPT_SRC = 'https://assets.calendly.com/assets/external/widget.js'
const CALENDLY_STYLESHEET_HREF = 'https://assets.calendly.com/assets/external/widget.css'

export default function FormBlock({ scrollToRef }) {
  const calendlyUrl = useMemo(() => {
    return process.env.REACT_APP_CALENDLY_URL || 'https://calendly.com/kostiantinople/30min'
  }, [])
  const windowInnerWidth = useUserStore((state) => state.windowInnerWidth);

  useEffect(() => {
    if (!document.querySelector(`link[href="${CALENDLY_STYLESHEET_HREF}"]`)) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = CALENDLY_STYLESHEET_HREF
      document.head.appendChild(link)
    }

    if (!document.querySelector(`script[src="${CALENDLY_SCRIPT_SRC}"]`)) {
      const script = document.createElement('script')
      script.src = CALENDLY_SCRIPT_SRC
      script.async = true
      document.body.appendChild(script)
    }
  }, [])

  return (
    <Box sx={{ width: "100%",
        height: "auto",
        px: windowInnerWidth < 960 ? "20px" : "80px",
        display: "flex",
        justifyContent: "center",
        }}>
        <Box ref={scrollToRef} sx={{ width: '100%', maxWidth: '1280px', }}>
            <AnimatedTitle text="Запис на консультацію" whiteColor={false} sx={{ mb: '24px' }} />
            <div
                className="calendly-inline-widget"
                data-url={calendlyUrl}
                style={{ minWidth: '280px', height: '720px', width: '100%' }}
            />
        </Box>
    </Box>
    
  )
}